<template>
  <CRow>
    <CCol col="12" lg="12">
      <CAlert color="danger" closeButton :show.sync="dismissCountDown" fade>
        {{ err_msg }}
      </CAlert>
      <CCard>
        <CCardHeader>
          <strong>{{ $lang.recruitments.crud.publish }}</strong>
        </CCardHeader>
        <CForm novalidate @submit.prevent="onSubmit" enctype='multipart/form-data'>
          <CCardBody>
            <CRow>
                <CCol md="6">
                  <div class="form-group">
                    <label class="form__label">Publish to Recruiter </label><br>
                    <input type="checkbox" :value="0"
                           @change="changedIsAndroid" v-model="publish_to_recruiter"/>
                  </div>
                </CCol>
                <CCol md="6" v-show="publish_to_recruiter == 1">
                  <div class="form-group">
                    <label class="form__label">Commission </label><br>
                    <input class="form-control" type="text" v-model="commission"/>
                  </div>
                </CCol>
                <CCol md="6">
                  <div class="form-group">
                    <label class="form__label">Publish to Candidate </label><br>
                    <input type="checkbox" :value="0" @change="changedIsIos"
                           v-model="publish_to_candidate"/>
                  </div>
                </CCol>
                <CCol md="6" v-show="publish_to_candidate == 1">
                  <div class="form-group">
                    <label class="form__label">Referral Bonus </label><br>
                    <input class="form-control" type="text" v-model="referral_bonus"/>
                  </div>
                </CCol>
            </CRow>
          </CCardBody>
          <CCardFooter>
            <CButton
                type="submit"
                size="sm"
                color="primary"
                :disabled="submitted"
            >
              <CIcon name="cil-check-circle"/>
              {{ $lang.buttons.general.crud.submit }}
            </CButton>
            <CButton color="danger" size="sm" @click="cancel">
              <CIcon name="cil-ban"/>
              {{ $lang.buttons.general.crud.cancel }}
            </CButton>
          </CCardFooter>
        </CForm>
      </CCard>
    </CCol>
  </CRow>
</template>
<script>
import Vue from "vue";
import VueForm from "vue-form";
import store from "/src/store/store.js";
import {
  projects,
  industry,
  duration,
  currencytype,
  users,
  skills,
} from "/src/store/url.js";
import {Mixin} from "/src/mixins/index.js";
import options from "/src/validations/validations.js";
import VueNotifications from "vue-notifications";
import {required} from "vuelidate/lib/validators";
import required_span from "../../components/layouts/general/required-span";
import VueToasted from "vue-toasted";
import moment from "moment";

function toast({title, message, type, timeout, cb}) {
  if (type === VueNotifications.types.warn) type = "show";
  return Vue.toasted[type](message, {
    duration: timeout,
    position: "top-left",
  });
}

Vue.use(VueToasted);
const optionss = {
  success: toast,
  error: toast,
  info: toast,
  warn: toast,
  position: "top-center",
};
Vue.use(VueNotifications, optionss);
Vue.use(VueForm, options);

export default {
  name: "RecruitmentPublish",
  mixins: [Mixin],
  components: {
    required_span
  },
  data() {
    return {
      submitted: false,
      err_msg: "",
      commission: "",
      referral_bonus: "",
      dismissCountDown: 0,
      remoteWorkOptions: [],
      skillsOptions: [],
      publish_to_candidate : 0,
      publish_to_recruiter : 0,
      industryOptions: [],
      subIndustryOptions: [],
      currencyOptions: [],
      durationOptions: [],
      userOptions: [],
      countryOptions: [],
      getSkills: [],
      cityOptions: [],
      bottomMenuOptions: [],
      experienceOptions: [],
      educationOptions: [],
      bottomMenuList: [{
        id: '0',
        selected: '',
        city: [],
        cityList: []
      }],
      hiringOptions : [
        {
          value: 1,
          label: "Self"
        },
        {
          value: 2,
          label: "Client"
        },
      ],
      jobTypeOptions : [
        {
          value: 3,
          label: "Full-Time"
        },
        {
          value: 4,
          label: "Part-Time"
        },
      ],
      employmentTypeOptions : [
        {
          value: 1,
          label: "Permanent"
        },
        {
          value: 2,
          label: "Contract"
        },
      ],
      workTypeOptions : [
        {
          value: 1,
          label: "Onsite"
        },
        {
          value: 2,
          label: "Remote"
        },
        {
          value: "3",
          label: "Hybrid"
        },
      ],
      baseOptions : [
        {
          value: 1,
          label: "Skill"
        },
        {
          value: 2,
          label: "Experience"
        },
        {
          value: 3,
          label: "Both"
        },
      ],
      self: this,
      module: projects,
      moduleIndustry: industry,
      moduleDuration: duration,
      moduleCurrency: currencytype,
      moduleUser: users,
      moduleSkills: skills,
      recruitments: {
        hire_for : "",
        industry : "",
        job_title : "",
        client : "",
        job_type : "",
        employment_type : "",
        work_type : "",
        dates : "",
        no_of_opening : "",
        description : "",
        recent_skills : [],
        other_skills : [],
        education : [],
        experience : "",
        currency : "",
        budget : "",
        max_budget : "",
        hire_based_on : "",
        owner_name : "",
        owner_contact : "",
        owner_email : "",
        uploadFieldName : [],
        media : [],
        companyLogo : "",
        mediadetail : "",
      },
    };
  },
  validations: {
    recruitments: {
      job_title: {
        required,
      },
      hire_for: {
        required,
      },
      job_type: {
        required,
      },
      employment_type: {
        required,
      },
      work_type: {
        required,
      },
      dates: {
        required,
      },
      no_of_opening: {
        required,
      },
      description: {
        required,
      },
      recent_skills: {
        required,
      },
      other_skills: {
        required,
      },
      education: {
        required,
      },
      experience: {
        required,
      },
      max_experience: {
        required,
      },
      currency: {
        required,
      },
      budget: {
        required,
      },
      max_budget: {
        required,
      },
      hire_based_on: {
        required,
      },
      owner_name: {
        required,
      },
      owner_contact: {
        required,
      },
      owner_email: {
        required,
      },
      industry: {
        required,
      },
    },
  },
  mounted() {
    let self = this;
    store.commit("showLoader", false); // Loader Off
    self.remoteWorkOptions.push(
        {value: "Yes", label: "Yes"},
        {value: "No", label: "No"}
    );
    self.dismissCountDown = 0;
    axios.get(this.listUrlApi(this.moduleIndustry)).then((response) => {
      response.data.data.map(function (value, key) {
        if (value.industryId === "") {
          self.industryOptions.push({value: value.id, label: value.industry});
        }
      });
    });
    axios.get(this.listUrlApi(this.moduleDuration)).then((response) => {
      response.data.data.map(function (value, key) {
        self.durationOptions.push({value: value.id, label: value.title});
      });
    });
    axios.get(this.listUrlApi(this.moduleCurrency)).then((response) => {
      response.data.data.map(function (value, key) {
        self.currencyOptions.push({value: value.id, label: value.title});
      });
    });
    axios.get('/countries/lists').then((response) => {
      response.data.data.map(function (value, key) {
        self.countryOptions.push({value: value.id, label: value.name});
      });
    });
    axios.get('/experiences/list').then((response) => {
      response.data.data.map(function (value, key) {
        self.experienceOptions.push({value: value.id, label: value.title});
      });
    });
    axios.get('/educations/list').then((response) => {
      response.data.data.map(function (value, key) {
        self.educationOptions.push({value: value.id, label: value.title});
      });
    });
    const id = this.$route.params.id;
    axios.get('job-opening/view/' + id).then((response) => {
      if (response) {
        let responseData = response.data.data;
        self.publish_to_candidate = responseData.jobCandidatePublish?.jobStatusId;
        self.referral_bonus = responseData.jobCandidatePublish?.referralBonus;

        self.publish_to_recruiter = responseData.jobRecruiterPublish?.jobStatusId;
        self.commission = responseData.jobRecruiterPublish?.commission;
      }
    });

  },
  methods: {
    changedIsIos(e) {
      let self = this;
      this.v = e.target.checked;
      if (this.v) {
        self.publish_to_candidate = 1;
      } else {
        self.publish_to_candidate = 0;
      }
    },
    changedIsAndroid(e) {
      let self = this;
      this.v = e.target.checked;
      if (this.v) {
        self.publish_to_recruiter = 1;
      } else {
        self.publish_to_recruiter = 0;
      }
    },
    changeCity(index, val) {
      let self = this;
      axios.get('/cities/country/list/' + val.value).then((response) => {
        self.bottomMenuList[index].city = [];
        self.bottomMenuList[index].cityList = [];
        response.data.data.map(function (value, key) {
          self.bottomMenuList[index].cityList.push({value: value.id, label: value.name});
        });
      });
    },
    addMenu() {
      this.bottomMenuList.push({
        id: `${++this.menuCounter}`,
        selected: '',
        city: [],
        cityList: [],
      });
    },
    subMenu(id) {
      let self = this;
      const myArr = self.bottomMenuList;
      const index = myArr.findIndex(function (o) {
        return o.id === id;
      });
      if (index !== 0) myArr.splice(index, 1);
    },
    getHumanDate: function (date) {
      return moment(date, "YYYY-MM-DD").format("DD/MM/YYYY");
    },
    changedIsActive(e) {
      let self = this;
      this.v = e.target.checked;
      if (this.v) {
        self.recruitments.isActive = 1;
      } else {
        self.recruitments.isActive = 0;
      }
    },
    getSubIndustry() {
      let self = this;
      if (self.recruitments.industry.value > 0) {
        // const postData = {industry_id: self.recruitments.industry.value};
        // axios
        //     .post(this.listUrlApi(this.moduleIndustry), postData)
        //     .then((response) => {
        //       self.subIndustryOptions = [];
        //       response.data.data.map(function (value, key) {
        //         if (value.industryId > 0) {
        //           self.subIndustryOptions.push({
        //             value: value.id,
        //             label: value.SubIndustry,
        //           });
        //         }
        //       });
        //     });

        let self = this;
        const postData = {industry_id: self.recruitments.industry.value};
        self.recruitments.recent_skills = [];
        self.recruitments.other_skills = [];
        self.skillsOptions = [];
        axios.post(this.listUrlApi(this.moduleSkills), postData).then((response) => {
          response.data.data.map(function (value, key) {
            self.skillsOptions.push({value: value.id, label: value.title});
          });
        });

      }
    },
    sendAlert() {
      this.$root.$emit("alert", "test1", "test2");
    },
    onSubmit() {
      let self = this;
      self.submitted = true; //Disable Button
      this.submitStatus = "PENDING";
      setTimeout(() => {
        let self = this;
        let formData = new FormData();
        formData.append('publishToCandidate',self.publish_to_candidate);
        formData.append('publishToRecruiter',self.publish_to_recruiter);
        formData.append('commission',self.commission);
        formData.append('jobId',this.$route.params.id);
        formData.append('referralBonus',self.referral_bonus);
        axios
            .post('/job-opening/publish', formData)
            .then(function (response) {
              self.submitted = false; //Enable Button
              if (response.data.code === 200) {
                localStorage.setItem("showAlert", "This is my alert");
                self.sendAlert();
                self.$router.push({path: "/job-openings"});
              } else {
                self.err_msg = response.data.message;
                self.dismissCountDown = 10;
              }
            })
            .catch(function (error) {
              self.submitted = false; //Enable Button
            });
      }, 500);
    },
    cancel() {
      self.submitted = false; //Enable Button
      this.usersOpened
          ? this.$router.go(-1)
          : this.$router.push({path: "/job-openings"});
    },
  },
};
</script>
<style>
div .error {
  color: red;
}

.hasError label {
  color: red;
}
</style>
